import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";
import { statusLabel } from "@/lib/statusLabel.js";

export function MyStuffPage() {
  const { ui } = useOrignalUi();
  const [data, setData] = useState(null);
  useEffect(() => {
    api("/api/me/affaires").then(setData).catch(() => {});
  }, []);
  if (!data) return <main className="og-page" data-testid="page-mystuff"><p>{ui.app.loading}</p></main>;
  return (
    <main className="og-page" data-testid="page-mystuff">
      <h1>{ui.nav.myStuff}</h1>
      <section className="og-card">
        <h3>{ui.prep.card}</h3>
        {(data.items || []).length === 0 ? <p className="og-hint">{ui.prep.knownOnly}</p> : null}
        {(data.items || []).map((i) => (
          <article key={i.id} className="og-prep-item">
            <strong>{i.name}</strong>
            <span className="og-badge">{statusLabel(ui, i.status)}</span>
          </article>
        ))}
        <Link className="og-btn og-btn--primary" to="/preparation">{ui.nav.prep}</Link>
      </section>
      <section className="og-card">
        <h3>{ui.nav.tasks}</h3>
        {(data.tasks || []).map((t) => <p key={t.id}>{t.title} · {statusLabel(ui, t.status)}</p>)}
      </section>
      <section className="og-card">
        <h3>{ui.trip.food}</h3>
        {(data.food || []).map((f) => <p key={f.id}>{f.item}</p>)}
      </section>
      <section className="og-card">
        <h3>{ui.nav.documents}</h3>
        {(data.documents || []).map((d) => <p key={d.id}><a href={d.url} target="_blank" rel="noreferrer">{d.title}</a></p>)}
      </section>
      <section className="og-card">
        <h3>{ui.nav.expenses}</h3>
        {(data.expenses || []).map((e) => <p key={e.id}>{e.description} — {e.amount} $</p>)}
      </section>
    </main>
  );
}
